module.exports = __webpack_public_path__ + "static/media/Nick.5b4abaaf.png";